import { Suspense } from "react"
import { useParams, Navigate } from "react-router-dom"
import { Loader2 } from "lucide-react"
import { toolsById } from "@/tools/registry"

export function ToolPage() {
  const { id } = useParams<{ id: string }>()
  const tool = id ? toolsById[id] : undefined

  if (!tool) return <Navigate to="/" replace />

  const Component = tool.component
  return (
    <Suspense
      fallback={
        <div className="flex-1 flex items-center justify-center text-muted-foreground">
          <Loader2 className="w-5 h-5 animate-spin mr-2" />
          加载中...
        </div>
      }
    >
      <div className="flex-1 min-h-0 overflow-hidden">
        <Component />
      </div>
    </Suspense>
  )
}
